import { QueryClient } from "@tanstack/react-query";

/**
 * QueryClient central (TanStack Query).
 * Defauts choisis pour un SIS : on evite les refetch agressifs, 1 seule reprise.
 *  - staleTime 30s  : les donnees restent "fraiches" 30s -> pas de refetch a chaque montage.
 *  - gcTime 5 min   : conservees en cache 5 min apres inactivite.
 *  - retry 1        : une seule reprise sur echec reseau.
 *  - refetchOnWindowFocus false : pas de refetch au retour sur l'onglet (UX SIS).
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});
